import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-tosite-pudotusalue',
  templateUrl: './tosite-pudotusalue.component.html',
  styleUrls: ['./tosite-pudotusalue.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TositePudotusalueComponent {
  @Input() tiivis = false
  @Output() tiedostotValittu = new EventEmitter<File[]>()

  @ViewChild('tiedostoInput') tiedostoInput: ElementRef<HTMLInputElement>

  raahaus = false

  avaaTiedostonValinta() {
    this.tiedostoInput.nativeElement.click()
  }

  tiedostotMuuttui(event: Event) {
    const input = event.target as HTMLInputElement
    if (!input.files || input.files.length === 0) {
      return
    }
    this.tiedostotValittu.emit(Array.from(input.files))
    input.value = ''
  }

  kasitteleTiedostojenRaahausYli(event: DragEvent) {
    event.preventDefault()
    this.raahaus = true
  }

  kasitteleTiedostojenRaahausPois() {
    this.raahaus = false
  }

  kasitteleTiedostojenPudotus(event: DragEvent) {
    event.preventDefault()
    this.raahaus = false
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.tiedostotValittu.emit(Array.from(event.dataTransfer.files))
    }
  }
}
